// RUN BUILD WITH: ng build --configuration=dev

export const environment = {
  production: false,
  url: 'https://devcms.job.rocks/',
  apiUrl: 'https://devcms.job.rocks/api',
  ibanApi: "https://services.job.rocks/",
  chatUrl: "http://localhost:3000/",
  chatApiUrl: "http://localhost:3000/api",

  iosAppLink: "https://apps.apple.com/us/app/medicalis/id6751336606",
  androidAppLink: "https://play.google.com/store/apps/details?id=com.sihp.jobrocks.medicalis",

  logoUrl: 'assets/images/logo_medicalis.png',
  favIconUrl: 'assets/images/logo_medicalis.png',
  agencyName: 'medicalis',

  // monitoring
  sentryDsn: 'https://3af19c63fd69f6191da152fcb513d320@o4511032735039488.ingest.de.sentry.io/4511038077534288',
  sentryEnvironment: 'dev',
};